module.exports = ":host,main{display:block}main{font-family:Roboto,Open Sans,Arial,sans-serif}"